// extracted by mini-css-extract-plugin
export var image = "_i0-1";
export var imageContainer = "_i0-0";